"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isListProperty = exports.listPropertyDefinition = void 0;
exports.listPropertyDefinition = {
    view: {
        label: 'List',
        style: 'list',
    },
    constraints: [],
    type: 'rich-text',
    multiple: true,
    name: 'list',
};
const isListProperty = (prop) => {
    return prop.name === exports.listPropertyDefinition.name;
};
exports.isListProperty = isListProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2xpc3QucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsTUFBTTtRQUNiLEtBQUssRUFBRSxNQUFNO0tBQ2Q7SUFDRCxXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLE1BQU07Q0FDbUIsQ0FBQTtBQUkxQixNQUFNLGNBQWMsR0FBRyxDQUFDLElBQWtCLEVBQXdCLEVBQUU7SUFDekUsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhCQUFzQixDQUFDLElBQUksQ0FBQTtBQUNsRCxDQUFDLENBQUE7QUFGWSxRQUFBLGNBQWMsa0JBRTFCIn0=